import { User } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { UserVO } from './user.vo';

/**
 * Type authentication pour typer le retour de la commande user info
 */
export type AuthType = {
  accontExpired?: boolean;
  accountNonLocked?: boolean;
  authorities?: { authority: string }[];
  credentialsNonExpired?: boolean;
  enabled?: true;
  internalUser?: User;
  password?: null;
  username?: string;
};

/**
 * VO représentant l'authentification du user
 */
export class AuthVO {
  
  private _internalUser: UserVO;

  constructor(public model: Model, public source: AuthType = {}) {

  }

  /**
   * Accès au user Interne, un UserVO, représentation AllkeyMe du user
   */
  public get internalUser(): UserVO {
    if (!this._internalUser && this.source.internalUser) {
      this._internalUser = new UserVO(this.model, this.source.internalUser);
    }

    return this._internalUser;
  }

  public set internalUser(pValue: UserVO) {
    this._internalUser = pValue;
  }

  /**
   * Indique si il s'agit d'un nouvel utilisateur qui vient de s'inscrire sur l'application
   */
  public get isNew(): boolean {
    return !this.internalUser?.id;
  }
}
